import { JSXElement, mergeProps } from 'solid-js';
import PortalCustomizations from '~/portal-customization';
import PreviewModeContextProvider from '~/components/AppData/PreviewModeContext.tsx';

type HostedAuthContainerProps = {
  children: JSXElement;
};

export default function HostedAuthContainer(
  props: HostedAuthContainerProps
): JSXElement {
  const merged = mergeProps({}, props);

  return (
    <PreviewModeContextProvider>
      <PortalCustomizations>{merged.children}</PortalCustomizations>
    </PreviewModeContextProvider>
  );
}
